import { Injectable } from '@angular/core';
import { StrictBehavior } from '../../behavior';
import { BehaviorContext } from '../../behavior-context';
import { PgLinearLoaderFactoryComponent } from 'projects/grit-core/src/lib/pg-linear-loader/pg-linear-loader-factory/pg-linear-loader-factory.component';

@Injectable()
export class StopLoaderBehavior extends StrictBehavior {
  executeBehavior(
    args: { loaderId: string; minDuration: number },
    ctx: BehaviorContext
  ): Promise<any> {
    return new Promise(res => {
      const loaderFactory: PgLinearLoaderFactoryComponent = ctx.getFactoryById(
        args.loaderId
      );
      const startTime: Date = ctx.get(`loaderStartTime-${args.loaderId}`);
      if (args.minDuration && startTime) {
        const remainingTime =
          args.minDuration - (new Date().getTime() - startTime.getTime());
        setTimeout(() => {
          res();
        }, remainingTime);
      } else {
        loaderFactory.linearLoader.hidden = true;
      }
      loaderFactory.linearLoader.loaderHidden.subscribe(() => {
        res();
      });
    });
    // loaderFactory.linearLoader.hidden = false;
  }
}
